/**
 * Кнопка добавления чего-то важного.
 * Располагается в верхнем левом углу, над деревом.
 * Добавлено с целью стандартизации.
 */
import { PlusCircleOutlined } from "@ant-design/icons";
import * as React from "react";
import { SolidButton } from "src/components/buttons/SolidButton";
import styles from "./AddButton.module.less";

interface PropsAddButton {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  id: string; // для автотестирования
}

export const AddButton: React.FC<PropsAddButton> = ({
  text,
  onClick,
  disabled,
  id,
}) => (
  <SolidButton
    icon={<PlusCircleOutlined />}
    onClick={onClick}
    disabled={disabled}
    id={id}
    className={styles.addButton}
  >
    {text}
  </SolidButton>
);
